import React, { useState } from 'react';
import './Contact.css';

const Contact: React.FC = () => {
  const [form, setForm] = useState({ designation: '', frequency: '', mission: '' });
  const [sent, setSent] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSent(true);
    setTimeout(() => setSent(false), 3000);
  };

  return (
    <section className="contact" id="contact">
      <div className="contact__content">
        <div>
        <p className="contact__eyebrow">COMMUNICATION</p>
        <h2 className="contact__heading">Initiate<br />Contact.</h2>
        <p className="contact__sub">
          Ready to discuss a new project or a technical project? <br />Select your preferred protocol:
        </p>
        </div>
        <div className="contact__info">
          <div className="contact__info-item">
            <span className="contact__info-icon">✉</span>
            <div>
              <p className="contact__info-label">EMAIL PROTOCOL</p>
              <a href="mailto:ascent@engineer.io" className="contact__info-value">austinhancs@gmail.com</a>
            </div>
          </div>
          <div className="contact__info-item">
            <span className="contact__info-icon">&lt;/&gt;</span>
            <div>
              <p className="contact__info-label">GITHUB REPOSITORY</p>
              <a href="https://github.com/StinnyJHH" target="_blank" rel="noreferrer" className="contact__info-value">github.com/StinnyJHH</a>
            </div>
          </div>
          <div className="contact__info-item">
            <span className="contact__info-icon">◎</span>
            <div>
              <p className="contact__info-label">BASECAMP</p>
              <span className="contact__info-value">Wilmington, Delaware</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
